import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import BCXFormValues from '@/components/molecules/forms/BCXFormValues.vue';
import { BcxFormValueField } from '@/models/BcxForm';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';
import { ComponentInvoicePaymentData } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePaymentDataDisplay',
  props: {
  paymentData: {
    type: Object as PropType<ComponentInvoicePaymentData>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { tUserFallback: t } = useUser('self');
const { isMobileWidth } = useResponsiveness();

const horizontalGap = isMobileWidth.value ? '16px' : '40px';

const displayedPaymentData = computed(() => {
  const {
    accountName, bic, iban, taxRate, reverseCharge, currency, ...rest
  } = props.paymentData;
  return {
    ...rest,
    taxRate: `${taxRate}${taxRate.toString().includes('%') ? '' : ' %'}`,
    reverseCharge: `${t(`invoice.payment-data.reverseChargeOptions.${reverseCharge}_USERTYPE`)}`,
    currency: `${t(`invoice.payment-data.currencyOptions.${currency}_USERTYPE`)}`,
    account: {
      accountName,
      bic,
      iban
    }
  };
});

const baseFields = computed(() => {
  const fields: BcxFormValueField[] = [
    {
      name: 'account',
      width: '67%',
      label: `${t('invoice.payment-data.form.account_USERTYPE')}`
    },
    {
      name: 'currency',
      width: '33%',
      label: `${t('invoice.payment-data.form.currency_USERTYPE')}`
    }
  ];
  return fields;
});

const taxFields = computed(() => {
  const reverseChargeTaxId: BcxFormValueField = {
    name: 'reverseChargeTaxId',
    width: isMobileWidth.value ? '100%' : '33%',
    label: `${t('invoice.payment-data.form.reverseChargeTaxId_USERTYPE')}`
  };
  const fields: BcxFormValueField[] = [
    {
      name: 'taxId',
      width: isMobileWidth.value ? '50%' : '33%',
      label: `${t('invoice.payment-data.form.taxId_USERTYPE')}`
    },
    {
      name: 'taxRate',
      width: isMobileWidth.value ? '50%' : '34%',
      label: `${t('invoice.payment-data.form.tax_USERTYPE')}`
    },
    {
      name: 'reverseCharge',
      width: isMobileWidth.value ? '100%' : '33%',
      label: `${t('invoice.payment-data.form.reverseCharge_USERTYPE')}`
    },
    ...(props.paymentData?.reverseCharge ? [{ ...reverseChargeTaxId }] : [])
  ];
  return fields;
});

return { __sfc: true,props, t, isMobileWidth, horizontalGap, displayedPaymentData, baseFields, taxFields, BCXFormValues }
}

})